"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultAddress = exports.getFetchingRecentError = exports.getSavingRecentError = exports.hasChangesError = exports.hasCanSpamSettingsLoaded = exports.hasCanSpamSettingsSavingError = exports.isCanSpamSettingsSaving = exports.hasCanSpamSettingsFetchingError = exports.getOriginalCanSpamSettings = exports.getEditableCanSpamSettings = void 0;

var _underscore = require("underscore");

var getEditableCanSpamSettings = function getEditableCanSpamSettings(state) {
  return state.canSpamSettings.editableCanSpamSettings;
};

exports.getEditableCanSpamSettings = getEditableCanSpamSettings;

var getOriginalCanSpamSettings = function getOriginalCanSpamSettings(state) {
  return state.canSpamSettings.originalCanSpamSettings;
};

exports.getOriginalCanSpamSettings = getOriginalCanSpamSettings;

var hasCanSpamSettingsFetchingError = function hasCanSpamSettingsFetchingError(state) {
  return state.canSpamSettings.fetchingHasError;
};

exports.hasCanSpamSettingsFetchingError = hasCanSpamSettingsFetchingError;

var isCanSpamSettingsSaving = function isCanSpamSettingsSaving(state) {
  return state.canSpamSettings.saving;
};

exports.isCanSpamSettingsSaving = isCanSpamSettingsSaving;

var hasCanSpamSettingsSavingError = function hasCanSpamSettingsSavingError(state) {
  return state.canSpamSettings.savingHasError;
};

exports.hasCanSpamSettingsSavingError = hasCanSpamSettingsSavingError;

var hasCanSpamSettingsLoaded = function hasCanSpamSettingsLoaded(state) {
  return state.canSpamSettings.hasLoaded;
};

exports.hasCanSpamSettingsLoaded = hasCanSpamSettingsLoaded;

var hasChangesError = function hasChangesError(state) {
  return state.canSpamSettings.hasChangesError;
};

exports.hasChangesError = hasChangesError;

var getSavingRecentError = function getSavingRecentError(state) {
  return state.canSpamSettings.savingRecentError;
};

exports.getSavingRecentError = getSavingRecentError;

var getFetchingRecentError = function getFetchingRecentError(state) {
  return state.canSpamSettings.fetchingRecentError;
};

exports.getFetchingRecentError = getFetchingRecentError;

var getDefaultAddress = function getDefaultAddress(canSpamSettings) {
  return (0, _underscore.findWhere)(canSpamSettings.objects, {
    isDefault: true
  });
};

exports.getDefaultAddress = getDefaultAddress;